<div class="container">
  <app-media-lockable class="lock" [config]="config().lock" (unlocked)="mediaLockUnlocked()" (error)="mediaLockError()" />
  <div class="ui-container">
    @if (showButton()) {
      <app-button class="ui-button" [config]="config().button" />
    }
  </div>
</div>
